import Modal from '@/components/modals/modal/modal.vue'
import emitHideMixin from '@/components/modals/mixins/emit-hide'
import VueNumericInput from 'vue-numeric-input'
import { getShortId } from '@/utils/format-strings'

export default {
  name: 'SendInProgressOrdersModal',
  /**
   * emitHideMixin - методы hide и onHideModal
   */
  mixins: [ emitHideMixin ],

  props: {
    ordersToRemake: {
      type: Array,
      default: () => []
    }
  },
  
  components: {
    Modal,
    VueNumericInput
  },

  data() {
    return {
      selectedIds: {}
    }
  },

  computed: {
    resultArray() {
      let result = []
      const keysOrders = Object.keys(this.selectedIds)
      for (let i = 0; i < keysOrders.length; i++) {
        const keyOrder = keysOrders[i]
        const orderItems = this.selectedIds[keyOrder]
        /**
         * на всякий случай
         */
        if (orderItems) {
          const itemArrays = Object.values(orderItems)
          const resultItemsArray = [].concat(...itemArrays)
          result = result.concat(resultItemsArray)
        }
      }
      return result
    },
    itemPluralaziton() {
      const count = this.resultArray.length

      if (count >= 10 && count <= 20) {
        return 'штук'
      }
      const remainder = count % 10
      if (remainder === 1) {
        return 'штука'
      }
      if (remainder >= 2 && remainder <= 4) {
        return 'штуки'
      }      
      return 'штуки'
    }
  },

  methods: {
    getShortId,

    show () {
      this.selectedIds = this.ordersToRemake.reduce((acc, order) => {
        acc[order.id] = order.items.reduce((accItems, item, index) => {
          accItems[index] = []
          return accItems
        }, {})
        return acc
      }, {})
      this.$refs.modal.show()
    },

    onClose() {
      this.selectedIds = {}
      this.onHideModal()
    },

    onInputCount(event, orderId, itemIndex, orderItemIds) {
      this.selectedIds[orderId][itemIndex] = orderItemIds.slice(0, event)
    },

    onSend() {
      this.$emit('send', this.resultArray)
    }
  }
}